import React from "react";
import classes from "./CareerOutcomes.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";

interface CareerOutcomesProps {
  countryData?: any;
}

const CareerOutcomes: React.FC<CareerOutcomesProps> = ({ countryData }) => {
  const isMobile = useIsMobile(768);
  const { emblaRef, canScrollPrev, canScrollNext, scrollPrev: goToPrev, scrollNext: goToNext } = useEmblaOverflow();

  const careerOutcomesData = countryData?.careerOutcomes;

  const arrowLeft = (
    <div
      className={`${classes["co-arrow"]}${canScrollPrev ? "" : ` ${classes["co-arrow-disabled"]}`}`}
      onClick={canScrollPrev ? goToPrev : undefined}
      aria-disabled={!canScrollPrev}
    >
      <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="Previous" />
    </div>
  );

  const arrowRight = (
    <div
      className={`${classes["co-arrow"]}${canScrollNext ? "" : ` ${classes["co-arrow-disabled"]}`}`}
      onClick={canScrollNext ? goToNext : undefined}
      aria-disabled={!canScrollNext}
    >
      <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="Next" />
    </div>
  );

  const arrowButtons = (
    <>
      {arrowLeft}
      {arrowRight}
    </>
  );

  return (
    <section id="career" className={classes["co-section"]}>
      <div className={classes["co-container"]}>
        <h2 className={classes["co-heading"]}>{careerOutcomesData?.title ?? ""}</h2>
        <div className={classes["co-subtext"]} dangerouslySetInnerHTML={{ __html: careerOutcomesData?.description ?? "" }}></div>

        <h3 className={classes["co-subheading"]}>Top Recruiters</h3>

        {isMobile ? (
          <div className={classes["co-carousel-wrap"]}>
            <div className={classes["co-viewport"]} ref={emblaRef}>
              <div className={classes["co-slider"]}>
                {careerOutcomesData?.topRecruiters?.map((rec: any) => (
                  <div key={rec.id} className={classes["co-slide"]}>
                    <div className={classes["co-recruiter-card"]}>
                      <CustomImage src={rec.logo?.url ?? "/new-images/default-logo.svg"} alt={rec.name} width={100} height={50} objectFit="contain" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes["co-arrows-below"]}>{arrowButtons}</div>
          </div>
        ) : (
          <div className={classes["co-carousel-wrap"]}>
            {arrowLeft}
            <div className={classes["co-viewport"]} ref={emblaRef}>
              <div className={classes["co-slider"]}>
                {careerOutcomesData?.topRecruiters?.map((rec: any) => (
                  <div key={rec.id} className={classes["co-slide"]}>
                    <div className={classes["co-recruiter-card"]}>
                      <CustomImage src={rec.logo?.url ?? "/new-images/default-logo.svg"} alt={rec.name} width={120} height={50} objectFit="contain" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {arrowRight}
          </div>
        )}

        <h3 className={classes["co-jobs-heading"]}>{careerOutcomesData?.tableTitle ?? ""}</h3>

        {careerOutcomesData?.jobSalary && careerOutcomesData?.jobSalary?.length > 0 && (
          <div className={classes["co-table"]}>
            <div className={`${classes["co-table__row"]} ${classes["co-table__header"]}`}>
              <span>{careerOutcomesData?.column1Title ?? ""}</span>
              <span>{careerOutcomesData?.column2Title ?? ""}</span>
            </div>
            {careerOutcomesData?.jobSalary?.map((job: any) => (
              <div key={job.id} className={classes["co-table__row"]}>
                <span>{job.jobProfile}</span>
                <span>{job.averageSalary}</span>
              </div>
            ))}
          </div>
        )}

        <p className={classes["co-note"]}>{careerOutcomesData?.tableNote ?? ""}</p>
      </div>
    </section>
  );
};

export default CareerOutcomes;
